var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 871,
    height: 394,
    transform: "translate(-451 -162)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24.0039,
    height: 24,
    rx: 4,
    fill: "#59D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H12V13H13V12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H13V14H14V13Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H14V15H15V14Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H14V13H15V12Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14H12V15H13V14Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.99998C13.4846 10.0137 12.9848 9.82274 12.61 9.46879C12.2351 9.11484 12.0158 8.62679 12 8.11148C12.0094 7.74358 12.1226 7.38582 12.3266 7.07953L13.585 5.20703C13.6334 5.14274 13.696 5.09056 13.768 5.05463C13.84 5.0187 13.9193 5 13.9998 5C14.0803 5 14.1596 5.0187 14.2316 5.05463C14.3036 5.09056 14.3662 5.14274 14.4146 5.20703L15.6577 7.05498C15.87 7.3674 15.9888 7.73392 16 8.11148C15.9842 8.62679 15.7649 9.11484 15.39 9.46879C15.0152 9.82274 14.5154 10.0137 14 9.99998ZM14 6.38158L13.1719 7.61283C13.0684 7.75937 13.0088 7.93232 13 8.11148C13.0158 8.36152 13.1298 8.59517 13.3171 8.76158C13.5044 8.92799 13.7498 9.01367 14 8.99998C14.2502 9.01367 14.4956 8.92799 14.6829 8.76158C14.8702 8.59517 14.9842 8.36152 15 8.11148C14.9888 7.92272 14.9237 7.74113 14.8125 7.58818L14 6.38158Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C17.7349 6.0003 17.4807 6.10576 17.2932 6.29323C17.1058 6.4807 17.0003 6.73488 17 7V17H7V9H8V13L8.5 14L9 13V9H10V11L10.5 12L11 11V8H7V7C6.9997 6.73488 6.89424 6.4807 6.70677 6.29323C6.5193 6.10576 6.26512 6.0003 6 6H5V7H6V17C6.0003 17.2651 6.10576 17.5193 6.29323 17.7068C6.4807 17.8942 6.73488 17.9997 7 18H17C17.2651 17.9997 17.5193 17.8942 17.7068 17.7068C17.8942 17.5193 17.9997 17.2651 18 17V7H19V6H18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.0575ab373930cc44fbc8af27afa57638.svg";
export { ForwardRef as ReactComponent };